<template>
	<div
			id="services-page"
			class="home"
			:class="theme">
		<nav-bar></nav-bar>
		<swiper :options="swiperOption" ref="mySwiper2">
			<swiper-slide>
				<div style="height: 100%; background-image: url('../assets/img/mir4.jpg'); background-size: cover; background-repeat: no-repeat;">
					<div class="slide-center">
						<h1 class="page__title-white">{{ $t('Services') }}</h1>
					</div>
				</div>
			</swiper-slide>
		</swiper>

		<!--
			<img src="../assets/img/mir4.jpg" alt="">
			-->

		<div id="quote-form" class="page">
			<h1 class="page__title">{{ $t('Services') }}</h1>
			<hr class="page__hr">


			<p> {{ $t('Services_text_01') }}.
</p>


			<p> {{ $t('Services_text_02') }}.
</p>


			<div class="page__container main">

				<div class="services-item">
					<div class="icon-container">
						<icon name="balance-scale" scale="2" color="lightsteelblue"></icon>
					</div>

					<div class="icon-container">
						{{ $t('Official_Appraisals') }}

					</div>
				</div>
				<div class="services-item">
					<div class="icon-container">
						<icon name="globe" scale="2" color="lightsteelblue"></icon>
					</div>

					<div class="icon-container">
						{{ $t('Energy_Certificates') }}





					</div>
				</div>
				<div class="services-item">
					<div class="icon-container">
						<icon name="home" scale="2" color="lightsteelblue"></icon>
					</div>

					<div class="icon-container">
						{{ $t('Occupancy_Cards') }}









					</div>
				</div>
				<div class="services-item">
					<div class="icon-container">
						<icon name="pencil" scale="2" color="lightsteelblue"></icon>
					</div>

					<div class="icon-container">
						{{ $t('Building_surveys') }}









					</div>
				</div>
				<div class="services-item">
					<div class="icon-container">
						<icon name="gavel" scale="2" color="lightsteelblue"></icon>
					</div>

					<div class="icon-container">
						{{ $t('Expert_Opinions') }}
					</div>
				</div>


			</div>

			<!--

			<p>{{ $t('Services_text_03') }}.</p>


			<div class="page__container main">

				<div class="page__content left">
					<ul>
						<p><strong>Informatives</strong></p>
						<li>{{ $t('Property_purchase-sale') }}</li>
						<li>{{ $t('Assets_value_update') }}</li>
						<li>{{ $t('Testamentary_shares') }}</li>
						<li>Reestructuració de Societats</li>
						<li>Actualització de balanços</li>
						<li>Actuacions administratives</li>
						<li>Expropiacions</li>
						<li>Valoracions Cadastrals</li>
						<li>Temes contenciosos</li>
						<li>Contenciosos del TSJC</li>
						<li>Altres (consultar)</li>
					</ul>
				</div>

				<div class="page__content right">
					<ul>
						<p><strong>Hipotecàries o subjectes a l'Ordre ECO 805/2003</strong></p>

						<li>
							Garantia hipotecària de préstecs









						</li>
						<li>
							Pagaments a hisenda









						</li>
						<li>
							Cobertura de Provisions









						</li>
						<li>
							Determinació del patrimoni de Grups d'Inversió Col·lectiva









						</li>
						<li>
							Determinació del patrimoni de Fons de Pensions









						</li>
						<li>
							Altres (consultar)









						</li>
					</ul>
				</div>

			</div>

			<h1 class="page__title">{{ $t('Property_types') }}</h1>
			<hr class="page__hr">

			{{ $t('Services_text_04') }}:







			<div class="page__container main">

				<div class="page__content left">
					<ul>
						<p><strong>Béns immobles i drets</strong></p>
						<li>
							Habitatges en edifici plurifamiliar (pisos, apartaments, àtics, dúplexs, lofts...)









						</li>
						<li>
							Habitatges unifamiliars (torres, xalets unifamiliars, adossats, entre mitgeres...)









						</li>
						<li>
							Locals Comercials









						</li>
						<li>
							Oficines









						</li>
						<li>
							Places de Garatge i Trasters









						</li>
						<li>
							Naus industrials









						</li>
						<li>
							Edificis sencers (d'ús Residencial, Comercial, Oficines, Mixt o alters....)









						</li>
						<li>
							Edificis lligats a una Activitat Econòmica (Hotels, Residències, Escoles, Hospitals...)







						</li>
						<li>
							Edificis en fase de projecte o construcció de qualsevol ús









						</li>
						<li>
							Edificis en fase de rehabilitació









						</li>

						<li>
							Promocions Immobiliàries









						</li>
						<li>
							Terrenys: Urbans, Urbanitzables, No Urbanitzables...







						</li>
						<li>
							Finques Rústiques







						</li>
						<li>
							Concessions Administratives







						</li>
						<li>
							Drets Reals







						</li>
						<li>
							Servituds i Drets d'Ús







						</li>
						<li>
							Drets de Superfície







						</li>
						<li>
							Altres (consultar)









						</li>

					</ul>
				</div>

				<div class="page__content right">
					<ul>
						<p><strong>Altres tipologies</strong></p>

						<li>
							Mobiliari









						</li>
						<li>
							Maquinària









						</li>
						<li>
							Instal·lacions









						</li>
						<li>
							Altres (consultar)









						</li>
					</ul>
				</div>

			</div>

-->
			<!--
			<h1 class="page__title">Passos a seguir</h1>
			<hr class="page__hr">

			<div class="page__container main">

				<div class="page__content left">
					<ol>
						<li>
							Sol·licitud de pressupost (24h)







						</li>
						<li>
							{{ $t('Services_text_05') }}







						</li>
						<li>
							{{ $t('Services_text_06') }}







						</li>
						<li>
							{{ $t('Services_text_07') }}







						</li>
						<li>
							{{ $t('Services_text_08') }}







						</li>
					</ol>
				</div>

			</div>

			-->

			<!--



			<h1 class="page__title">{{ $t('What_you_need_to_provide') }}</h1>
			<hr class="page__hr">
			-->

		</div>
		<logo-bar></logo-bar>
		<footer-bar></footer-bar>
	</div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import Vue from 'vue'
    import { localStorageMixin } from '../mixins'
    import Message from '../components/Message.vue'
    import FooterBar from '../components/FooterBar.vue'
    import NavBar from '../components/NavBar.vue'
    import { swiper, swiperSlide } from 'vue-awesome-swiper'
    import LogoBar from '../components/LogoBar.vue'

    export default {
        name: 'services',

        mixins: [localStorageMixin],

        components: {
            Message,
            FooterBar,
            LogoBar,
            NavBar,
            swiper,
            swiperSlide
        },

        data: () => ({

            error: null,
            swiperOption: {
                spaceBetween: 30,
                centeredSlides: true,
                autoplay: 4000,
                autoplayDisableOnInteraction: false,
                effect: 'fade',
                speed: 2000
            }
        }),

        computed: {
            ...mapGetters(['user',
                'theme'])
        },

        methods: {
            ...mapActions(['LOG_IN_USER'
            ]),
            closeMessage () {
                this.error = null
            }
        },

        head: {
            title: {
                inner: 'Services'
            }
        }

    }
</script>

<style scoped>
	.swiper-container {
		height: 40vh;
		width: 100%;
	}

	.slide-img {
		width: 100%;
		height: auto;
	}

	.services-item {
		width: 30%;
		margin: 1rem;

	}

	.icon-container {
		text-align: center;
		width: 100%;
	}


</style>


// WEBPACK FOOTER //
// Services.vue?05692c26